import { Component } from '@angular/core';
import { App,Platform, Events, ModalController,AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { DataProvider } from '../providers/data/data';
import { LoginPage } from '../pages/login/login';
import { AuthProvider } from '../providers/auth/auth';
import { LabelProvider } from '../providers/label/label';
import { LogProvider } from '../providers/log/log';
import { MediaProvider } from '../providers/media/media';
import { TranslateService } from '@ngx-translate/core';
import { DealershipProvider } from '../providers/dealership/dealership';
import { OemProvider } from '../providers/oem/oem';
import { CommonProvider } from '../providers/common/common';
import { AuditProvider } from '../providers/audit/audit';
import { AuditScheduleProvider } from '../providers/audit-schedule/audit-schedule';
import { ActionPlanProvider } from '../providers/action-plan/action-plan';
import { PdfProvider } from '../providers/pdf/pdf';
import { NotificationsProvider } from '../providers/notifications/notifications';
import { HelpProvider } from '../providers/help/help';
import { BehaviorSubject } from 'rxjs';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = 'LoginPage';
  isProvidersInitialised : boolean = false;
  userData:any;
  private isUserAuthenticateSubject = new BehaviorSubject<boolean>(false);
  isUserAuthenticate$ = this.isUserAuthenticateSubject.asObservable();
  
  constructor(
    private app:App,
    platform: Platform, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen, 
    public events:Events,
    private storage: Storage,
    private dp:DataProvider,
    public authProvider: AuthProvider,
    public dataProvider:DataProvider,
    public labelProvider : LabelProvider,
    public translateService: TranslateService, 
    public logProvider:LogProvider, 
    public mediaProvider:MediaProvider,
    public dealershipProvider:DealershipProvider,
    public oemProvider:OemProvider,
    public commonProvider:CommonProvider,
    public auditProvider:AuditProvider,
    public auditScheduleProvider:AuditScheduleProvider,
    public actionPlanProvider:ActionPlanProvider,
    public pdfProvider:PdfProvider,
    public notificationsProvider:NotificationsProvider,
    public helpProvider:HelpProvider,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController) {
    
    translateService.setDefaultLang('en');
    translateService.use('en');
    
    this.labelProvider.intializeSubscriptions();
    this.logProvider.intializeSubscriptions();
    this.authProvider.intializeSubscriptions();
    this.checkAuth();


    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

       platform.resume.subscribe(() => {
            console.log("window resumed");
            this.events.publish('audit:reloadImages');
        });

      statusBar.styleDefault();
      splashScreen.hide();
      
      
    });
  }

  async ngOnInit() {
    this.isUserAuthenticate$.subscribe(async isUserAuthenticate => {
      if (isUserAuthenticate) {
        await this.initializeComponentAfterAuth();
      }
    });
  }

   checkAuth(){

    this.events.subscribe('user:authenticated', async () => {

        console.log("get user auth request");

          if(!this.isProvidersInitialised){
              this.isProvidersInitialised = true;
              this.intializeProviders();
          }
          // this.rootPage = 'TabsPage';
        this.isUserAuthenticateSubject.next(true);
           
   });

    this.events.subscribe('user:notActive', async () => {

     let alert = this.alertCtrl.create({
        title: "Account not active",
        subTitle: "Please check your email to activate your account",
        buttons: [{
            text: 'OK',
            handler: data => {
            }
          }]
       });
       alert.present();
           
   });


    this.events.subscribe('auth:logoutSuccess', () => {
        
        console.log("final logging out");
        this.rootPage ='LoginPage';
        this.isProvidersInitialised = false;
        this.removeProviders();
        
        

    });
  }

  async initializeComponentAfterAuth() {
    this.userData = await this.dataProvider.getUserData();

    if (this.userData && !this.userData.reason) {
      await this.openSetupModal();
    }

    this.rootPage = 'TabsPage';
  }

   intializeProviders(){

       this.dataProvider.intializeSubscriptions();
       this.mediaProvider.intializeSubscriptions();
       this.dealershipProvider.intializeSubscriptions();
       this.oemProvider.intializeSubscriptions();
       this.commonProvider.intializeSubscriptions();
       this.auditProvider.intializeSubscriptions();
       this.auditScheduleProvider.intializeSubscriptions();
       this.actionPlanProvider.intializeSubscriptions();
       this.pdfProvider.intializeSubscriptions();
       this.notificationsProvider.intializeSubscriptions();
       this.helpProvider.intializeSubscriptions();
       
   }

   removeProviders(){

       this.dataProvider.removeSubscriptions();
       this.mediaProvider.removeSubscriptions();
       this.dealershipProvider.removeSubscriptions();
       this.oemProvider.removeSubscriptions();
       this.commonProvider.removeSubscriptions();
       this.auditProvider.removeSubscriptions();
       this.auditScheduleProvider.removeSubscriptions();
       this.actionPlanProvider.removeSubscriptions();
       this.pdfProvider.removeSubscriptions();
       this.notificationsProvider.removeSubscriptions();
       this.helpProvider.removeSubscriptions();

   }

  async openSetupModal() {
    const modal = this.modalCtrl.create('SetupModalPage', {}, { cssClass: 'custom-setup-modal', enableBackdropDismiss: false });
    modal.onDidDismiss(() => {
      console.log("Setup modal dismissed");
    });
    await modal.present();
  }
  
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts